export default {
  SUPER_ADMIN: "super_admin",
  ACCOUNT_OWNER: "account_owner",
  ACCOUNT_ADMIN: "account_admin",
  SITE_MANAGER: "site_manager",
  SITE_ADMIN: "site_admin",
  VIEW_ONLY: "account_viewer",
  OPERATOR: "operator",
};
